import styled from "styled-components";

import { md3CardRadius } from "../../../shared/styles/md3Components";

export { Container, Main } from "../../../styles/adminPage";

export const MediaPreviewSquare = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: ${({ theme }) => md3CardRadius(theme)}px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surfaceTertiary};
  border: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.2rem;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
